export const light = "light";
export const dark = "dark";
export const thorThunderLight = "thorThunder-light";
export const thorThunderDark = "thorThunder-dark";
export const dracoMightLight = "dracoMight-light";
export const dracoMightDark = "dracoMight-dark";
